import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useFpB2bProductsInfo, type UseFpB2bProductsInfoProps } from '@cart-services/hooks/fp-b2b/use-fp-b2b-products-info'
import { getLatestPreOrderDeliveryDate } from '@cart-services/utils/findPreOrderProduct'
import { useMemo } from 'react'

type UsePreOrderDeliveryDateProps = Pick<UseFpB2bProductsInfoProps, 'campaignId' | 'projectCode' | 'countryCode' | 'campaignCode' | 'platform'>

/**
 * 取當前購物車最晚的預購出貨日，供 blockout-delivery-days 換算可選／預設到貨日。
 */
export const usePreOrderDeliveryDate = (props: UsePreOrderDeliveryDateProps): string | undefined => {
  const { campaignId, platform } = props
  const { productMap } = useFpB2bProductsInfo(props)
  const { items: cartItems } = useFpB2bCartService(campaignId, platform)

  return useMemo(
    () => getLatestPreOrderDeliveryDate(cartItems.map(item => productMap?.[item.cartItemId])),
    [cartItems, productMap],
  )
}
